import React from 'react';
export function AssociationsSection() {
  const associations = [{
    name: 'Michigan Manufacturers Association',
    href: 'https://mimfg.org/'
  }, {
    name: 'SME',
    href: 'https://www.sme.org/'
  }, {
    name: 'American Mold Builders Association',
    href: 'https://amba.org/'
  }];
  return <section className="py-12 md:py-16 bg-gray-50 border-y border-gray-200" data-id="element-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12" data-id="element-12">
          {associations.map((association, index) => <a key={index} href={association.href} target="_blank" rel="noopener noreferrer" className="group" aria-label={association.name} data-id="element-13">
              <div className="w-40 h-24 bg-white rounded-lg shadow-sm group-hover:shadow-md transition-shadow flex items-center justify-center border border-gray-200" data-id="element-14">
                <span className="text-gray-500 text-xs text-center px-4 font-medium" data-id="element-15">
                  {association.name}
                </span>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}